import React, {useEffect, useState} from 'react';
import {StyleSheet} from 'react-native';
import {ScrollView} from 'react-native';

import ActivityIndicator from '../../components/ui-controls/ActivityIndicator';
import ContentView from '../../components/ui-controls/layout/ContentView';
import Markdown from '../../components/ui-controls/Markdown';
import {AirtableInformation} from '../../models/airtable';
import {AppRoute} from '../../models/AppRoute';
import {
  InformationContentType,
  RouteNavigatorScreenProps,
} from '../../models/navigationTypes';
import theme from '../../style/theme';
import apiService from '../../transport/apiService';

function dashCaseToTitleCase(str: string) {
  return str
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
}

function InformationContentScreen({
  route,
}: RouteNavigatorScreenProps<AppRoute.INFORMATION_CONTENT>) {
  const [isLoading, setIsLoading] = useState(true);
  const [information, setInformation] = useState<AirtableInformation>();
  const contentType: InformationContentType = route.params?.target;

  useEffect(() => {
    async function initialise() {
      setIsLoading(true);
      const info =
        (await apiService.getInformation(
          dashCaseToTitleCase(contentType || ''),
        )) || [];
      setInformation(info.data);
      setIsLoading(false);
    }
    initialise();
  }, [contentType]);

  if (isLoading) {
    return (
      <ContentView testID="promotion-detail-screen">
        <ActivityIndicator />
      </ContentView>
    );
  }

  return (
    <ContentView>
      <ScrollView>
        {information ? (
          <Markdown style={style}>{information?.content}</Markdown>
        ) : null}
      </ScrollView>
    </ContentView>
  );
}

const style = StyleSheet.create({
  heading1: {
    color: theme.colour.text.heading.primary,
  },
  heading2: {
    color: theme.colour.text.heading.primary,
    marginVertical: 8,
  },
  heading3: {
    color: theme.colour.text.heading.primary,
  },
  link: {
    color: theme.colour.text.link.primary,
  },
  bullet_list_icon: {
    color: 'white',
  },
});

export default InformationContentScreen;
